
import { customElement, autoinject, transient, containerless } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { SynchronizationGrid } from "../synchronization-grid";
import { UserGridStateService } from "services/user-grid-state-service";
import { EventAggregator } from "aurelia-event-aggregator";

@transient()
@autoinject()
@customElement("budgets-synchronization-grid")
@containerless
export class BudgetsSynchronizationGrid extends SynchronizationGrid {

    constructor(element: Element, i18n: I18N, userGridStateService: UserGridStateService, eventAggregator: EventAggregator) {
        super(element, i18n, userGridStateService, eventAggregator);

    }

}
